module.exports = __webpack_public_path__ + "img/logo-dark.ea55090a.svg";